
import { validateNorwegianSsn } from '@n2-common/lib/norwegianSsn';
import * as Yup from 'yup';

export const norwegianNationalId =() => Yup.string().nullable().typeError('Vennligst fyll ut feltet.')
.required('Vennligst fyll ut feltet.').test('test-norwegiannationalid', // this is used internally by yup
'Vennligst oppgi et gyldig fødselsnummer (11 siffer)', //validation message
 // eslint-disable-next-line @typescript-eslint/no-unused-vars
 value => {
   if (!value) {
      return false;
    }
    return validateNorwegianSsn(value);
 });
